type UpdateCallback = (actualValue: number, isComplete: boolean) => void;

/**
 * Animates a value towards `destinationValue`.
 * An onUpdate callback, set in constructor, will for each "frame" with the actualValue.
 */
export class NaiveAnimator {
  private intervalId = 0;

  private actualValue = 0;

  private destinationValue = 0;

  private isAnimatingUpwards = false;

  private onUpdate: UpdateCallback;

  constructor(onUpdate: UpdateCallback, initialValue = 0) {
    this.onUpdate = onUpdate;

    this.actualValue = initialValue;
    this.destinationValue = initialValue;
  }

  public setActualValue(v: number): void {
    this.stop();
    this.actualValue = v;

    this.onUpdate(this.actualValue, false);
  }

  public setDestinationValue(v: number): void {
    this.destinationValue = v;
    this.isAnimatingUpwards = this.destinationValue > this.actualValue;

    this.start();
  }

  public getDestinationValue(): number {
    return this.destinationValue;
  }

  private start(): void {
    if (this.intervalId === 0) {
      this.intervalId = window.setInterval(this.update, 40);
    }
  }

  public stop(): void {
    window.clearInterval(this.intervalId);
    this.intervalId = 0;
  }

  private update = (): void => {
    this.actualValue += this.isAnimatingUpwards ? 0.15 : -0.15;

    let isComplete = false;

    if (
      (this.isAnimatingUpwards && this.actualValue >= this.destinationValue) ||
      (!this.isAnimatingUpwards && this.actualValue <= this.destinationValue)
    ) {
      this.stop();
      isComplete = true;
      this.actualValue = this.destinationValue;
    }

    this.onUpdate(this.actualValue, isComplete);
  };
}
